import { QueryClient } from '@tanstack/react-query';

/**
 * queryClient — Centralized React Query client
 *
 * Config tuned for ERP / CRM apps:
 *  • staleTime 5 min   — don't refetch data that was just loaded
 *  • gcTime 30 min     — keep cache alive across route changes
 *  • retry 2           — retry failed requests twice before showing error
 *  • refetchOnWindowFocus false  — no surprise refetches on tab switch
 *  • refetchOnReconnect true     — refetch when internet comes back
 *  • refetchOnMount false        — don't hit server again on re-navigation
 */
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,       // 5 minutes
      gcTime: 30 * 60 * 1000,         // 30 minutes
      retry: 2,
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      refetchOnMount: true,
    },
  },
});

export default queryClient;
